import ApiService from 'Services/ApiService'

export default {
    list(query = null) {
        return ApiService.get('events', query)
    },
    get(id, query) {
        return ApiService.get(`events/${id}`, query)
    },
    store(event) {
        return ApiService.post('events', event)
    },
    update(event) {
        return ApiService.put(`events/${event.id}`, event)
    },
    delete(id, query) {
        return ApiService.delete(`events/${id}`, {params: query})
    }
}